<template>
  <div>
  <lcontainer>
    <lheader />
    <hr class="mx-4 " />
    <div class="course-single " style="margin-top: 8%!important;">
      <div class="w-full md:flex items-center header px-4 pt-4 " >
        <div class="w-full self-start md:w-2/3">
          <div class="mb-2 px-2">
            <div class="text-2xl md:text-4xl text-white font-extrabold mb-6">
              {{ course.title }}
            </div>
            <div class="text-base font-medium text-white mb-8 md:w-3/4">
              {{ course.caption }}
            </div>
            <div
                    class="stats mb-6 text-white w-full flex items-center justify-between font-bold"
            >
              <!-- <div
                             class="w-full md:w-auto flex items-center justify-between md:mb-0 mb-6"
                           > -->
              <span
                      class="bg-white px-3 font-normal py-1 rounded bestseller md:mr-6 font-bold"
              >BESTSELLER</span
              >
              <span class="mr-1 md:mr-3">
                <star-rating
                        v-model="course.aggregate_rating"
                        :increment="0.1"
                        read-only
                        :star-size="20"
                ></star-rating>
              </span>
              <!-- </div> -->
              <span>{{ course.enrollee }} enrolled</span>
            </div>
            <div class="mb-4 text-white flex flex-wrap justify-between">
              <span class="">Created by: {{ author }} </span>
              <span class=""
              >Last updated: {{ course.updated_at | dateFilter }}</span
              >
              <span class="">Language: English</span>
            </div>
            <div class="actions">
              <template>
                <lms-button
                        @click="$router.push({ name: 'login-learners' })"
                        class="mr-6"
                        color="#fff"
                >Add to Cart</lms-button
                >

                <lms-button
                        @click="$router.push({ name: 'login-learners' })"
                        border
                >Add to Wishlist</lms-button
                >
              </template>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/3 flex-shrink mb-2 pb-2">
          <div class="mb-4 flex flex-col">
            <div class="price text-white text-3xl md:text-5xl md:text-center">
              {{ coursePrice }}
            </div>
            <div class="media relative" style="z-index: 1">
              <!-- make any media scale nicely -->
              <!-- <iframe class="media-item object-cover" src="https://www.youtube.com/embed/HIlG2NKnsVA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
              <img
                      v-if="!hasValidVideo"
                      class="media-item object-cover w-full"
                      :src="course.course_image"
                      alt=""
              />
              <div
                      class="overlay absolute top-0 left-0 h-full w-full flex justify-center items-center px-5 pt-5"
              >
                <span
                        v-if="hasValidVideo"
                        class="text-4xl cursor-pointer p-4 justify-center rounded-full h-20 w-20 flex items-center border-4 text-white"
                >
                  <i class="fas fa-play"></i>
                </span>
              </div>
            </div>
            <div
                    v-if="hasValidVideo"
                    class="text-center text-white font-bold mt-2"
            >
              Watch overview video
            </div>
          </div>
        </div>
      </div>
      <div class="course-details bg-white shadow mt-4 p-4">
        <div class="md:px-12 py-4 w-2/3">
          <div class="desc text-black">
            <div class="text-tenant-color text-2xl font-semibold">
              Description
            </div>
            <p v-html="course.description" class="story"></p>
          </div>

          <div class="require  my-2">
            <div class="text-tenant-color text-2xl font-semibold">
              Requirements
            </div>
            <div class="flex flex-col text-black">
              <div class="item" v-html="course.resources_required"></div>
            </div>
          </div>

          <div class="require  my-2">
            <div class="text-tenant-color text-2xl font-semibold">
              What you will learn
            </div>
            <div class="flex flex-col text-black">
              <div class="item" v-html="course.skills_gained"></div>
            </div>
          </div>
        </div>

        <!-- <div class="featured-review w-2/3">
                 <div class="px-12">
                   <div class="text-tenant-color text-2xl font-semibold my-6">
                     Featured Review
                   </div>
                   <div class="flex">
                     <div class="mr-4">
                       <div
                         style="height: 67px; width: 67px;"
                         class="self-start rounded"
                       >
                         <img
                           class="object-cover w-100 h-100 rounded-full"
                           src="https://avatars2.githubusercontent.com/u/15062380?s=460&u=2f400d9555dc07bc4d2c2d25483ddba570fef29b&v=4"
                           alt=""
                         />
                       </div>
                     </div>
                     <div class="">
                       <div class="text-tenant-color font-semibold text-lg mb-1">
                         Dapo Believe
                       </div>
                       <div class="text-black mb-6">
                         <div class="mb-4">2 months ago</div>
                         <div>
                           Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                           consectetur adipisicing elit. Nisi voluptates enim maxime
                           quos, quod. Architecto rerum eum rem ut necessitatibus.
                         </div>
                       </div>
                       <div class="inline-flex items-center">
                         <span class="mr-4 text-gray-500"
                           >Was this review helpful?
                         </span>
                         <span
                           class="px-4 rounded border tenant-border text-tenant-color cursor-pointer mr-4"
                           >Yes</span
                         >
                         <span
                           class="px-4 rounded border tenant-border text-tenant-color cursor-pointer"
                           >No</span
                         >
                       </div>
                     </div>
                   </div>
                 </div>
               </div> -->
        <div class="course-content w-full md:w-4/6 mt-4">
          <div class="md:px-12">
            <div class="text-tenant-color text-2xl font-semibold my-6">
              Course Content
            </div>
            <div>
              <accordion
                      :items="x.lessons"
                      :title="`${x.title}`"
                      :key="index"
                      v-for="(x, index) in sortedModules"
              />
            </div>
          </div>
        </div>
        <div class="featured-review w-2/3 mt-24">
          <div class="md:px-12">
            <div class="text-tenant-color text-2xl font-semibold my-6">
              All Reviews
            </div>
            <div
                    v-for="testimonial in testimonials"
                    :key="testimonial.id"
                    class="flex mb-8"
            >
              <div class="mr-4">
                <div
                        style="height: 50px; width: 50px;"
                        class="self-start rounded"
                >
                  <img
                          v-if="testimonial.user.image"
                          class="object-cover w-100 h-100 rounded-full"
                          :src="testimonial.user.image"
                          alt=""
                  />
                  <img
                          v-else
                          class="object-cover w-150 h-150 rounded-full"
                          src="https://picsum.photos/id/1011/3648.jpg"
                          alt=""
                  />
                </div>
              </div>
              <div class="">
                <div class="text-tenant-color font-semibold text-lg mb-1">
                  {{ testimonial.user.name }}
                </div>
                <div class="text-black  mb-6">
                  <div class="mb-4 text-xs">
                    {{ testimonial.created_at | fromNow }}
                  </div>
                  <div>
                    {{ testimonial.testimonial }}
                  </div>
                </div>
                <!-- <div class="inline-flex items-center">
                                 <span class="mr-4 text-gray-500"
                                   >Was this review helpful?
                                 </span>
                                 <span
                                   class="px-4 rounded border tenant-border text-tenant-color cursor-pointer mr-4"
                                   >Yes</span
                                 >
                                 <span
                                   class="px-4 rounded border tenant-border text-tenant-color cursor-pointer"
                                   >No</span
                                 >
                               </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";

import _get from "lodash.get";
export default {
  mixins: [SettingsMixin],
  name: "single-course",
  data() {
    return {
      fullDetails: false,
      detailsText: "+ see more",
      videoFormats: ["mp4"],
      paidCourses: this.$store.state.learner.courses,
      sortedModules: null,
      testimonials: null,
    };
  },
  watch: {
    fullDetails: function(newVal, oldVal) {
      if (newVal) {
        this.detailsText = "- see less";
      } else {
        this.detailsText = "+ see more";
      }
    },
  },
  methods: {
    ...mapActions([
      "fetchExternalSingleCourse",
      "learnerAddToCart",
      "fetchCourseOpenTestimonials",
    ]),
    sortModules(modules) {
      modules.sort((a, b) => {
        return a.module_number - b.module_number;
      });
    },
    // click button
    addToCart() {
      this.learnerAddToCart({
        ...this.course,
      });
    },
    // pass course as payload to addToCart function
    // send to backend
    // set in state
  },
  computed: {
    ...mapGetters({
      course: "getExternalCourse",
      cart: "getLearnerCart",
    }),
    skills() {
      return this.course.skills_gained.split(",");
    },
    author() {
      return this.course.course_instructor
        ? `${this.course.course_instructor.first_name} ${this.course.course_instructor.last_name}`
        : "Course Instructor";
    },
    hasValidVideo() {
      let x = this.course.course_image.split(".");
      return this.videoFormats.includes(x[x.length - 1]);
    },
    coursePrice() {
      return typeof this.course.price !== "undefined"
        ? `${this.course.currency}${this.course.price}`
        : "FREE";
    },
    courseInCart() {
      return Object.keys(this.cart).includes(this.course.id);
    },
    hasPaid() {
      return typeof this.paidCourses[this.course.id] === "object";
    },
  },
  components: {
    accordion: () => import("@/components/general/accordion"),
    LmsButton: () => import("@/components/general/button"),
    lheader: () => import("@/components/shared/home/header"),
    lcontainer: () => import("@/components/general/container"),
  },
  async created() {
    let res = await this.fetchExternalSingleCourse({
      id: this.$route.params.id,
    });
    this.sortedModules = res.data.data.course.modules.sort((a, b) => {
      return a.module_number - b.module_number;
    });
    let prefix = new URL(this.getURI).host.split(".")[0]; //chnage url to window.location.href

    this.testimonials = await this.fetchCourseOpenTestimonials({
      id: this.$route.params.id,
      prefix: prefix,
    });

    //console.log({ rs: this.sortedModules });
  },
};
</script>
<style lang="scss">
.course-single {
  .header {
    background-color: color(lms-tenant);
  }

  .stats {
    .bestseller {
      color: color(lms-tenant);
    }
  }

  .media {
    height: 200px;

    .media-item {
      height: 100%;
      width: 100%;
    }
    .overlay {
      background-color: rgba(0 0 0 / 0.6);
    }
  }

  .keypoints {
    .top {
      color: color(lms-tenant);
    }

    .point {
      color: #000;
      span {
        color: color(lms-tenant);
      }
    }
  }

  .course-details {
    .showFull {
      max-height: 130px;
      overflow: hidden;
      margin-bottom: 2rem;
    }
    .shade {
      background: linear-gradient(
        180deg,
        #ffffff00 0%,
        #ffffffc7 50%,
        #ffffff 100%
      );
      filter: blur(0.2px);
      -webkit-filter: blur(0.2px);
      height: 7rem;
      margin-top: -9rem;
    }
  }
}
</style>
